import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
// Enums
import { FolderableBulkActionType } from 'FoldersApp/enums/folderable-bulk-action-type.enum';
// Services
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
// State
import { setBulkSelectedFolderablesOperation } from 'FoldersApp/state/bulk-selected-folderables/bulk-selected-folderables-operation.action';
import * as i0 from "@angular/core";
import * as i1 from "FoldersApp/services/bulk-action-selection.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i6 from "../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i7 from "FoldersApp/features/folders-shared/folderable-bulk-action-modal-wrapper/folderable-bulk-action-modal-wrapper.component";
function FolderableBulkActionMenuComponent_Conditional_1_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵlistener("click", function FolderableBulkActionMenuComponent_Conditional_1_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.close()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 13);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Close");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
} }
function FolderableBulkActionMenuComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 3)(2, "button", 4);
    i0.ɵɵlistener("click", function FolderableBulkActionMenuComponent_Conditional_1_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.clearSelections()); });
    i0.ɵɵtext(3, "Clear");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 5)(5, "span", 6)(6, "div", 7);
    i0.ɵɵelementStart(7, "div", 8)(8, "button", 9);
    i0.ɵɵlistener("click", function FolderableBulkActionMenuComponent_Conditional_1_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.selectBulkAction(ctx_r1.BulkActionType.MOVE)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 10);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(10, FolderableBulkActionMenuComponent_Conditional_1_button_10_Template, 2, 2, "button", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("textContent", ctx_r1.bulkActionSelectionService.numSelectedItems + " selected");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", "Move");
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "folderable-bulk-move-button")("disabled", !ctx_r1.bulkActionSelectionService.hasSelectedItems());
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("font-size", "1rem");
    i0.ɵɵproperty("name", "icon-move-folder");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.bulkActionSelectionService.bulkActionAlwaysEnabled);
} }
function FolderableBulkActionMenuComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 14);
    i0.ɵɵlistener("click", function FolderableBulkActionMenuComponent_Conditional_2_Template_span_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.open()); });
    i0.ɵɵtext(2, "Select Multiple Items");
    i0.ɵɵelementEnd()();
} }
export class FolderableBulkActionMenuComponent {
    constructor(bulkActionSelectionService, store) {
        this.bulkActionSelectionService = bulkActionSelectionService;
        this.store = store;
        this.isOpen = false;
        this.BulkActionType = FolderableBulkActionType;
        this.unsubscribe = new Subject();
    }
    ngOnInit() {
        this.bulkActionSelectionService.bulkActionMode$.pipe(takeUntil(this.unsubscribe)).subscribe((mode) => {
            this.isOpen = mode;
        });
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    selectBulkAction(action) {
        switch (action) {
            case FolderableBulkActionType.MOVE:
                this.store.dispatch(setBulkSelectedFolderablesOperation({
                    selectedOperation: {
                        idsByResourceType: this.bulkActionSelectionService.currentItems,
                        operation: action.valueOf(),
                    },
                }));
                break;
            default:
                throw new Error(`Unknown action type ${action}`);
        }
    }
    clearSelections() {
        this.bulkActionSelectionService.clearSelections();
    }
    open() {
        // Clear selections to make the items$ observable emit a new value.
        // This will force change detection in folderable item templates.
        this.bulkActionSelectionService.clearSelections();
        this.bulkActionSelectionService.setBulkActionEnabled(true);
    }
    close() {
        // Clear selections to make the items$ observable emit a new value.
        // This will force change detection in folderable item templates.
        this.bulkActionSelectionService.clearSelections();
        this.bulkActionSelectionService.setBulkActionEnabled(false);
    }
}
FolderableBulkActionMenuComponent.ɵfac = function FolderableBulkActionMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableBulkActionMenuComponent)(i0.ɵɵdirectiveInject(i1.BulkActionSelectionService), i0.ɵɵdirectiveInject(i2.Store)); };
FolderableBulkActionMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableBulkActionMenuComponent, selectors: [["ycn-folderable-bulk-action-menu"]], standalone: false, decls: 4, vars: 1, consts: [[1, "tr"], [1, "td", "td-multiselect"], [1, "td", "width-full"], [1, "mr-auto", "d-flex", "align-items-center"], [1, "btn", "btn-transparent2", 3, "click"], [1, "divider-vertical", "align-self-stretch", "mb-1", "mt-1", "mr-12"], [3, "textContent"], [1, "divider-vertical", "align-self-stretch", "mb-1", "mt-1", "ml-12", "mr-2"], ["ycnTooltip", "", 3, "tooltipTitle"], ["ycnDisabled", "", 1, "btn", "btn-transparent2", "active", "btn-circle", "btn-xs", 3, "click", "id", "disabled"], ["role", "img", "ycnIcon", "", 1, "icon-move-folder", 3, "name"], ["class", "btn btn-text btn-circle btn-xs", "ycnTooltip", "", 3, "tooltipTitle", "click", 4, "ngIf"], ["ycnTooltip", "", 1, "btn", "btn-text", "btn-circle", "btn-xs", 3, "click", "tooltipTitle"], ["role", "img", "ycnIcon", "", 1, "icon-close", 3, "name"], [1, "text-small", "text-underline-hover", "text-20", 3, "click"]], template: function FolderableBulkActionMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, FolderableBulkActionMenuComponent_Conditional_1_Template, 11, 8, "div", 1)(2, FolderableBulkActionMenuComponent_Conditional_2_Template, 3, 0, "div", 2);
        i0.ɵɵelement(3, "ycn-folderable-bulk-action-modal-wrapper");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isOpen ? 1 : 2);
    } }, dependencies: [i3.NgIf, i4.IconDirective, i5.TooltipDirective, i6.DisabledDirective, i7.FolderableBulkActionModalWrapperComponent], encapsulation: 2 });
